import Box from '@app/components/common/Box';
import Button from '@app/components/common/Button';
import {
  selectNumberOfPrepStationVersions,
  selectPrepStationVersionsOfCurrentKitchenTicketSettings,
} from '@app/state/selectors/settingsSelectors';
import { WithTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SelectPrepStationsToApplyChangesModal from '../SelectPrepStationsToApplyChangesModal';
import { IPrepStationToSelect } from '@westondev/tableturn-core';
import { prepStationVersionsSelectionFactory } from '@app/helpers/factories/settings/kitchenTicketSettings/prepStationVersionsFactory';

interface IApplyChangesToOtherPrepStationsButton extends WithTranslation {
  versionIndex: number;
  modalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  onApplyChanges: (stations: IPrepStationToSelect[]) => void;
  formattedDifferences: {
    prepStationVersions: { id: number }[];
  };
}

const ApplyChangesToOtherPrepStationsButton = ({
  t,
  versionIndex,
  modalOpen,
  openModal,
  closeModal,
  onApplyChanges,
  formattedDifferences,
}: IApplyChangesToOtherPrepStationsButton) => {
  //redux
  const prepStationVersions = useSelector(
    selectPrepStationVersionsOfCurrentKitchenTicketSettings,
  );

  const numberOfPrepStationVersions = useSelector(
    selectNumberOfPrepStationVersions,
  );

  const prepStationId =
    formattedDifferences.prepStationVersions[versionIndex]?.id ?? 0;

  const handleSelectAllPrepStations = () => {
    const allPrepStations = prepStationVersions
      ? prepStationVersionsSelectionFactory(prepStationVersions)
          .filter(
            prepStationVersion =>
              prepStationVersion.prepStationId !== prepStationId,
          )
          .map(prepStation => {
            return { ...prepStation, selected: true };
          })
      : [];

    onApplyChanges(allPrepStations);
  };

  return (
    <>
      <SelectPrepStationsToApplyChangesModal
        isActive={modalOpen}
        setModalActive={closeModal}
        onApplyChanges={onApplyChanges}
        prepStationId={prepStationId}
      />
      <Box csx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
        <Button
          csx={{ paddingLeft: 20, paddingRight: 20 }}
          variant="primary"
          onClick={openModal}
          disabled={numberOfPrepStationVersions === 1}>
          {t(
            'app.modals.kitchenTicketDiffModal.prepStations.applyChangesToOtherPrepStation.title',
          )}
        </Button>
        <Button
          csx={{ paddingLeft: 20, paddingRight: 20 }}
          variant="primary"
          onClick={handleSelectAllPrepStations}
          disabled={numberOfPrepStationVersions === 1}>
          {t(
            'app.modals.kitchenTicketDiffModal.prepStations.applyChangesToOtherPrepStation.applyChangesToAllPrepStations',
          )}
        </Button>
      </Box>
    </>
  );
};

export default ApplyChangesToOtherPrepStationsButton;
